/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Listen_BodyInputs */

const en_mcp_cap_listen_body = /** @type {(inputs: Mcp_Cap_Listen_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything your agent sends is waiting for you on iPhone, Android and the web.`)
};

const es_mcp_cap_listen_body = /** @type {(inputs: Mcp_Cap_Listen_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo lo que envía tu agente te espera en iPhone, Android y la web.`)
};

/**
* | output |
* | --- |
* | "Everything your agent sends is waiting for you on iPhone, Android and the web." |
*
* @param {Mcp_Cap_Listen_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_listen_body = /** @type {((inputs?: Mcp_Cap_Listen_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Listen_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_listen_body(inputs)
	return en_mcp_cap_listen_body(inputs)
});